import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import {
    getCompanyProfileList, getContinentList, getFilteredCountryList, getRegionListing,
    getDepartmentList, getDivisionList, getRoleList, getSubDepartmentList,
    getUserDetails, registerUser, updateUser
} from '../../services/user.service';
import * as CryptoJS from "crypto-js";
import Select from "react-select";

import '../users/role.css';

const TEXT_REGEX   = /^[a-zA-Z0-9-_ ]{1,255}$/;
const Email_REGEX  = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const Mobile_REGEX = /^[0-9]{10}$/;

/* ── Scroll + focus + shake the first invalid field ─────────── */
const focusField = (ref) => {
    if (!ref?.current) return;
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    ref.current.focus();
    ref.current.classList.remove('role-field-shake');
    void ref.current.offsetWidth;           // force reflow
    ref.current.classList.add('role-field-shake');
    setTimeout(() => ref.current?.classList.remove('role-field-shake'), 600);
};

function Register() {

    /* ── form state ──────────────────────────────────────────── */
    const [disabled,     setDisabled]     = useState(false);
    const [errMsg,       setErrMsg]       = useState('');
    const [success,      setSuccess]      = useState(false);

    const [name,         setName]         = useState('');
    const [ErrName,      setErrName]      = useState('');

    const [email,        setEmail]        = useState('');
    const [ErrEmail,     setErrEmail]     = useState('');

    const [mobile,       setMobile]       = useState('');
    const [ErrMobile,    setErrMobile]    = useState('');

    const [role,         setRole]         = useState('');
    const [ErrRole,      setErrRole]      = useState('');

    const [division,     setDivision]     = useState('');
    const [ErrDivision,  setErrDivision]  = useState('');

    const [department,   setDepartment]   = useState('');
    const [ErrDepartment,setErrDepartment]= useState('');

    const [subDepartment,    setSubDepartment]    = useState('');
    const [ErrSubDepartment, setErrSubDepartment] = useState('');

    const [companyId,    setCompanyId]    = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState('');

    const [userStatus,    setUserStatus]    = useState('');
    const [ErrUserStatus, setErrUserStatus] = useState('');

    /* ── list data ───────────────────────────────────────────── */
    const [companies,      setCompanies]      = useState([]);
    const [roles,          setRoles]          = useState([]);
    const [divisions,      setDivisions]      = useState([]);
    const [departments,    setDepartments]    = useState([]);
    const [subDepartments, setSubDepartments] = useState([]);
    const [continents,     setContinents]     = useState([]);
    const [countries,      setCountries]      = useState([]);
    const [regions,        setRegions]        = useState([]);

    const [ErrCountries,  setErrCountries]  = useState('');
    const [ErrRegion,     setErrRegion]     = useState('');
    const [ErrContinent,  setErrContinent]  = useState('');

    const [country,   setCountry]   = useState(0);
    const [region,    setRegion]    = useState(0);
    const [continent, setContinent] = useState(0);

    const [selectedOptionsDivisionList, setOptionsDivisionList]       = useState(null);
    const [otherDivisions,              setOtherDivisions]            = useState([]);
    const [selectedOtherDivisions,      setSelectedOtherDivisions]    = useState([]);
    const [isSubDepartmentsLoaded,      setIsSubDepartmentsLoaded]    = useState(false);

    /* ── refs for focus-on-error (in DOM top→bottom order) ───── */
    const refCompany = useRef(null);
    const refRole    = useRef(null);
    const refStatus  = useRef(null);
    const refName    = useRef(null);
    const refEmail   = useRef(null);
    const refMobile  = useRef(null);

    /* ── routing ─────────────────────────────────────────────── */
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query              = useQuery();
    const userid             = query.get('data');
    const compid             = query.get('compid');
    const subDepartmentIdFromUrl = query.get('subDeptId');
    const isEdit             = !!(userid && userid !== '');

    /* ── helpers ─────────────────────────────────────────────── */
    const enc = (obj) =>
        CryptoJS.AES.encrypt(
            JSON.stringify({ ...obj, authToken: sessionStorage.getItem('LoggedInToken') }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();

    const token = (obj) => ({ token: enc(obj) });

    const resetUserInfo = () => {
        setName(''); setEmail(''); setMobile(''); setRole('');
        setDivision(''); setDepartment(''); setSubDepartment('');
        setCompanyId(''); setUserStatus('');
        setContinent(0); setCountry(0); setRegion(0);
    };

    /* ── initial load ────────────────────────────────────────── */
    useEffect(() => {
        const oData = token({});
        getContinentList(oData).then(r    => { if (r?.data?.data?.length) setContinents(r.data.data); });
        getCompanyProfileList(oData).then(r => { if (r?.data?.data?.length) setCompanies(r.data.data); });

        if (userid && compid) {
            const bytes      = CryptoJS.AES.decrypt(userid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypted  = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            getUserInfo(decrypted.userid);
            const oComp = token({ param_data: { company_id: decrypted.compid } });
            getRoleList(oComp).then(r       => { if (r?.data?.data?.length) setRoles(r.data.data); });
            getDepartmentList(oComp).then(r  => { if (r?.data?.data?.length) setDepartments(r.data.data); });
            getDivisionList(oComp).then(r    => { if (r?.data?.data?.length) setDivisions(r.data.data); });
        }
    }, []);

    /* ── sub-departments on department change ────────────────── */
    useEffect(() => {
        if (!department && !compid) return;
        const bytes      = CryptoJS.AES.decrypt(userid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
        const decrypted  = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        getSubDepartmentList(token({ param_data: { company_id: decrypted.compid,department_id: department } })).then(r => {
            if (r?.data?.data?.length) {
                setSubDepartments(r.data.data);
                setIsSubDepartmentsLoaded(true);
                if (subDepartmentIdFromUrl) setSubDepartment(subDepartmentIdFromUrl);
            } else { setSubDepartments([]); }
        }).catch(() => setSubDepartments([]));
    }, [department, subDepartmentIdFromUrl]);

    /* ── sync other-division chips when division list arrives ── */
    useEffect(() => {
        if (divisions.length > 0 && otherDivisions.length > 0) {
            setSelectedOtherDivisions(
                divisions.filter(d => otherDivisions.includes(d.id))
                         .map(d => ({ value: d.id, label: d.division_name }))
            );
        }
    }, [divisions, otherDivisions]);

    /* ── sync division select label ──────────────────────────── */
    useEffect(() => {
        if (division && divisions.length > 0) {
            const sel = divisions.find(d => d.id === division);
            if (sel) setOptionsDivisionList({ value: sel.id, label: sel.division_name });
        }
    }, [division, divisions]);

    /* ── fetch user (edit mode) ──────────────────────────────── */
    const getUserInfo = (userId) => {
        getUserDetails(token({ param_data: { user_id: userId } })).then(r => {
            if (r?.data?.data?.length) {
                const u = r.data.data[0];
                setCompanyId(u.company_id);  setRole(u.role_id);
                setDivision(u.division_id);  setDepartment(u.department_id);
                setOtherDivisions(u.other_division
                    ? u.other_division.split(",").map(id => Number(id.trim())) : []);
                setSubDepartment(u.sub_department_id);
                setContinent(u.continent_id); setName(u.name);
                setEmail(u.email);            setMobile(u.mobile);
                setUserStatus(u.status);
                fetchCountryList(u.continent_id, u.country_id);
                fetchRegionList(u.country_id,   u.region_id);
            }
        });
    };

    const fetchCountryList = (continent_id, sel = null) =>
        getFilteredCountryList(token({ param_data: { continent_id } })).then(r => {
            if (r?.data?.data?.length) { setCountries(r.data.data); if (sel) setCountry(sel); }
        });

    const fetchRegionList = (country_id, sel = null) =>
        getRegionListing(token({ param_data: { country_id } })).then(r => {
            if (r?.data?.data?.length) { setRegions(r.data.data); if (sel) setRegion(sel); }
        });

    /* ── event handlers ──────────────────────────────────────── */
    const handleCompanyId = (e) => {
        const v = e.target.value;
        setCompanyId(v);
        if (ErrCompanyId) setErrCompanyId('');
        const oComp = token({ param_data: { company_id: v } });
        getRoleList(oComp).then(r       => { if (r?.data?.data?.length) setRoles(r.data.data); });
        getDivisionList(oComp).then(r    => { if (r?.data?.data?.length) setDivisions(r.data.data); });
        getDepartmentList(oComp).then(r  => { if (r?.data?.data?.length) setDepartments(r.data.data); });
    };

    const handleRole = (e) => { setRole(e.target.value || 0); if (ErrRole) setErrRole(''); };

    const optionDivisionList = [
        { value: '', label: 'Select Division' },
        ...divisions.map(o => ({ value: o.id, label: o.division_name }))
    ];

    const handleDivision = (data) => { setOptionsDivisionList(data); setDivision(data.value); };

    const handleDepartment = (e) => {
        const id = e.target.value;
        if (!id) { setDepartment(0); setSubDepartments([]); return; }
        setDepartment(id);
        getSubDepartmentList(token({ param_data: { department_id: id } })).then(r =>
            setSubDepartments(r?.data?.data?.length ? r.data.data : [])
        ).catch(() => setSubDepartments([]));
    };

    const handleSubDepartment = (e) => setSubDepartment(e.target.value);
    const handleUserStatus    = (e) => { setUserStatus(e.target.value); if (ErrUserStatus) setErrUserStatus(''); };
    const handleContinentId   = (e) => { setContinent(e.target.value); fetchCountryList(e.target.value); };
    const handleCountryId     = (e) => { setCountry(e.target.value);   fetchRegionList(e.target.value); };
    const handleRegionId      = (e) => setRegion(e.target.value);

    const otherDivisionOptions = divisions
        .filter(o => o.id !== division)
        .map(o => ({ value: o.id, label: o.division_name }));
    const otherDivisionIds    = selectedOtherDivisions.map(o => o.value);
    const handleOtherDivisions = (sel) => setSelectedOtherDivisions(sel || []);

    /* ── submit with focus-on-first-error ────────────────────── */
    const handleSubmit = async (e) => {
        e.preventDefault();

        let firstInvalidRef = null;

        // Returns true if valid; records the first bad ref
        const check = (valid, setErr, msg, ref) => {
            if (!valid) {
                setErr(msg);
                if (!firstInvalidRef) firstInvalidRef = ref;
                return false;
            }
            setErr('');
            return true;
        };

        // Validate in DOM top→bottom order so the scroll targets the topmost error
        let ok = true;
        ok = check(TEXT_REGEX.test(companyId),  setErrCompanyId,  'Company is required',              refCompany) & ok;
        ok = check(TEXT_REGEX.test(role),        setErrRole,       'Role is required',                 refRole)    & ok;
        ok = check(TEXT_REGEX.test(userStatus),  setErrUserStatus, 'User Status is required',          refStatus)  & ok;
        ok = check(TEXT_REGEX.test(name),        setErrName,       'Name is required',                 refName)    & ok;
        ok = check(Email_REGEX.test(email),      setErrEmail,      'Valid Email is required',          refEmail)   & ok;
        ok = check(Mobile_REGEX.test(mobile),    setErrMobile,     '10-digit mobile number required', refMobile)  & ok;

        if (!ok) {
            focusField(firstInvalidRef);
            return;
        }

        isEdit ? updateData() : saveData();
    };

    /* ── persist ─────────────────────────────────────────────── */
    const saveData = () => {
        try {
            let otherDivisionValue = null;
            if (Array.isArray(otherDivisionIds) && otherDivisionIds.length > 0) {
                const values = [];
                if (division) values.push(division); // add only if exists
                values.push(...otherDivisionIds);
                otherDivisionValue = values.join(',');
            } else if (otherDivisionIds) {
                otherDivisionValue = otherDivisionIds;
            }
            const obj = {
                name, Email: email, 
                created_company_id: companyId,
                role_id: role || 0, 
                created_division_id: division || 0,
                other_division: otherDivisionValue ? `${otherDivisionValue}` : null, /*Array.isArray(otherDivisionIds)
                    ? (division + ',' + otherDivisionIds.join(',')) : otherDivisionIds || null,
                created_department_id: department || 0,*/
                continent_id: continent || 0, country_id: country || 0, region_id: region || 0,
                mobile, created_sub_dep_id: subDepartment || 0,
                status: userStatus, created_by: sessionStorage.getItem('LoggedInUserId'),
            };
            registerUser(token({ param_data: obj })).then(res => {
                if (res.data.errors?.errno > 0) { setErrMsg(res.data.message); setSuccess(false); }
                else { setSuccess(res.data.message); setDisabled(true); setErrMsg(false); resetUserInfo(); }
            });
        } catch (err) {
            setSuccess(false);
            setErrMsg(!err?.data ? 'No Server Response' : err.data?.status === 409 ? 'Data already exists' : 'Insert Failed');
        }
    };

    const updateData = () => {
        const bytes     = CryptoJS.AES.decrypt(userid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
        const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        try {
            const obj = {
                user_id: decrypted.userid, name, Email: email,
                updated_company_id: companyId, role_id: role,
                continent_id: continent || 0, country_id: country || 0, region_id: region || 0,
                updated_division_id: division,
                other_division: Array.isArray(otherDivisionIds) && otherDivisionIds.length > 0
                    ? (division + ',' + otherDivisionIds.join(',')) : division || null,
                updated_department_id: department, mobile,
                created_sub_dep_id: subDepartment, status: userStatus,
                created_by: sessionStorage.getItem('LoggedInUserId'),
            };
            updateUser(token({ param_data: obj })).then(res => {
                if (res.data.errors?.errno > 0) { setErrMsg(res.data.message); setSuccess(false); }
                else { setSuccess(res.data.message); setDisabled(true); setErrMsg(false); resetUserInfo(); }
            });
        } catch (err) {
            setSuccess(false);
            setErrMsg(!err?.data ? 'No Server Response' : err.data?.status === 409 ? 'Data already exists' : 'Update Failed');
        }
    };

    /* ── render ──────────────────────────────────────────────── */
    return (
        <div id="register-container" className="role-container">

            {/* Page Header */}
            <div className="role-header">
                <h2 className="role-title">
                    <span className="role-title-icon">{isEdit ? '✏️' : '👤'}</span>
                    {isEdit ? 'Update User' : 'Add New User'}
                </h2>
                <p className="role-subtitle">
                    {isEdit
                        ? 'Update user details and access settings'
                        : 'Fill in the details to create a new user account'}
                </p>
            </div>

            {/* Alerts */}
            {success && (
                <div id="register-alert-success" className="role-alert role-alert--success">
                    <span className="role-alert-icon">✅</span> {success}
                </div>
            )}
            {errMsg && !success && (
                <div id="register-alert-error" className="role-alert role-alert--error">
                    <span className="role-alert-icon">⚠️</span> {errMsg}
                </div>
            )}

            <form id="register-form" onSubmit={handleSubmit} className="role-form" noValidate>
                <div className="role-tab-panel">

                    {/* ── § 1  Account Information ──────────────── */}
                    <div className="reg-section">
                        <div className="reg-section-header">
                            <span className="reg-section-icon">🏢</span>
                            <div>
                                <h4 className="reg-section-title">Account Information</h4>
                                <p className="reg-section-desc">Company, role and status assignments</p>
                            </div>
                        </div>

                        <div className="reg-grid">

                            {/* Company */}
                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-company">
                                    Company <span className="role-required">*</span>
                                </label>
                                <div className="role-field-control">
                                    <select
                                        id="reg-company"
                                        ref={refCompany}
                                        className={`role-select${ErrCompanyId ? ' role-select--error' : ''}`}
                                        onChange={handleCompanyId}
                                        value={companyId}
                                    >
                                        <option value="">Select Company</option>
                                        {companies.length > 0
                                            ? companies.map(o =>
                                                <option key={o.company_id} value={o.company_id}>{o.company_name}</option>)
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrCompanyId && <span className="role-field-error">⚠ {ErrCompanyId}</span>}
                                </div>
                            </div>

                            {/* Role */}
                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-role">
                                    Role Code <span className="role-required">*</span>
                                </label>
                                <div className="role-field-control">
                                    <select
                                        id="reg-role"
                                        ref={refRole}
                                        className={`role-select${ErrRole ? ' role-select--error' : ''}`}
                                        onChange={handleRole}
                                        value={role}
                                    >
                                        <option value="">Select Role</option>
                                        {roles.length > 0
                                            ? roles.map(o =>
                                                <option key={o.id} value={o.id}>{o.role_name} / {o.role_short_name}</option>)
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrRole && <span className="role-field-error">⚠ {ErrRole}</span>}
                                </div>
                            </div>

                            {/* User Status */}
                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-status">
                                    User Status <span className="role-required">*</span>
                                </label>
                                <div className="role-field-control">
                                    <select
                                        id="reg-status"
                                        ref={refStatus}
                                        className={`role-select${ErrUserStatus ? ' role-select--error' : ''}`}
                                        onChange={handleUserStatus}
                                        value={userStatus}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    {ErrUserStatus && <span className="role-field-error">⚠ {ErrUserStatus}</span>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="reg-divider"></div>

                    {/* ── § 2  Personal Details ─────────────────── */}
                    <div className="reg-section">
                        <div className="reg-section-header">
                            <span className="reg-section-icon">🙍</span>
                            <div>
                                <h4 className="reg-section-title">Personal Details</h4>
                                <p className="reg-section-desc">User contact and identification information</p>
                            </div>
                        </div>

                        <div className="reg-grid">

                            {/* Name */}
                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-name">
                                    Full Name <span className="role-required">*</span>
                                </label>
                                <div className="role-field-control">
                                    <input
                                        id="reg-name"
                                        ref={refName}
                                        type="text"
                                        className={`role-input${ErrName ? ' role-select--error' : ''}`}
                                        value={name}
                                        onChange={(e) => { setName(e.target.value); if (ErrName) setErrName(''); }}
                                        placeholder="Enter full name"
                                        maxLength={255}
                                    />
                                    {ErrName && <span className="role-field-error">⚠ {ErrName}</span>}
                                </div>
                            </div>

                            {/* Email */}
                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-email">
                                    Email Address <span className="role-required">*</span>
                                </label>
                                <div className="role-field-control">
                                    <input
                                        id="reg-email"
                                        ref={refEmail}
                                        type="email"
                                        className={`role-input${ErrEmail ? ' role-select--error' : ''}`}
                                        value={email}
                                        onChange={(e) => { setEmail(e.target.value); if (ErrEmail) setErrEmail(''); }}
                                        placeholder="Enter email address"
                                    />
                                    {ErrEmail && <span className="role-field-error">⚠ {ErrEmail}</span>}
                                </div>
                            </div>

                            {/* Mobile */}
                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-mobile">
                                    Mobile Number <span className="role-required">*</span>
                                </label>
                                <div className="role-field-control">
                                    <input
                                        id="reg-mobile"
                                        ref={refMobile}
                                        type="tel"
                                        className={`role-input${ErrMobile ? ' role-select--error' : ''}`}
                                        value={mobile}
                                        onChange={(e) => { setMobile(e.target.value); if (ErrMobile) setErrMobile(''); }}
                                        placeholder="10-digit mobile number"
                                        maxLength={10}
                                    />
                                    {ErrMobile && <span className="role-field-error">⚠ {ErrMobile}</span>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="reg-divider"></div>

                    {/* ── § 3  Department & Division ────────────── */}
                    <div className="reg-section">
                        <div className="reg-section-header">
                            <span className="reg-section-icon">🏛️</span>
                            <div>
                                <h4 className="reg-section-title">Department &amp; Division</h4>
                                <p className="reg-section-desc">Organizational structure assignments</p>
                            </div>
                        </div>

                        <div className="reg-grid">

                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-dept">Control Department</label>
                                <div className="role-field-control">
                                    <select id="reg-dept" className="role-select" value={department} onChange={handleDepartment}>
                                        <option value="">Select Department</option>
                                        {departments.length > 0
                                            ? departments.map(o => <option key={o.id} value={o.id}>{o.department_name}</option>)
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrDepartment && <span className="role-field-error">⚠ {ErrDepartment}</span>}
                                </div>
                            </div>

                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-subdept">Sub Control Department</label>
                                <div className="role-field-control">
                                    <select id="reg-subdept" className="role-select" value={subDepartment} onChange={handleSubDepartment}>
                                        <option value="">Select Sub Department</option>
                                        {subDepartments.length > 0
                                            ? subDepartments.map(o => <option key={o.id} value={o.id}>{o.sub_department_name}</option>)
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrSubDepartment && <span className="role-field-error">⚠ {ErrSubDepartment}</span>}
                                </div>
                            </div>

                            <div className="role-field-group">
                                <label className="role-field-label">Default Branch (Division)</label>
                                <div className="role-field-control reg-react-select-wrap">
                                    <Select
                                        inputId="reg-division"
                                        options={optionDivisionList}
                                        placeholder="Select One"
                                        value={selectedOptionsDivisionList}
                                        onChange={handleDivision}
                                        classNamePrefix="reg-select"
                                    />
                                    {ErrDivision && <span className="role-field-error">⚠ {ErrDivision}</span>}
                                </div>
                            </div>

                            {division && (
                                <div className="role-field-group">
                                    <label className="role-field-label">Additional Branch (Other Divisions)</label>
                                    <div className="role-field-control reg-react-select-wrap">
                                        <Select
                                            inputId="reg-other-divisions"
                                            options={otherDivisionOptions}
                                            isMulti
                                            placeholder="Select One or More"
                                            value={selectedOtherDivisions}
                                            onChange={handleOtherDivisions}
                                            classNamePrefix="reg-select"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="reg-divider"></div>

                    {/* ── § 4  Geographic Assignment ────────────── */}
                    <div className="reg-section">
                        <div className="reg-section-header">
                            <span className="reg-section-icon">🌍</span>
                            <div>
                                <h4 className="reg-section-title">Geographic Assignment</h4>
                                <p className="reg-section-desc">Continent, country and region for this user</p>
                            </div>
                        </div>

                        <div className="reg-grid">

                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-continent">Continent</label>
                                <div className="role-field-control">
                                    <select id="reg-continent" className="role-select" value={continent} onChange={handleContinentId}>
                                        <option value="">Select Continent</option>
                                        {continents.length > 0
                                            ? continents.map(o => <option key={o.id} value={o.id}>{o.continent_name}</option>)
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrContinent && <span className="role-field-error">⚠ {ErrContinent}</span>}
                                </div>
                            </div>

                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-country">Country</label>
                                <div className="role-field-control">
                                    <select id="reg-country" className="role-select" value={country} onChange={handleCountryId}>
                                        <option value="">Select Country</option>
                                        {countries.length > 0
                                            ? countries.map(o => <option key={o.id} value={o.id}>{o.country_name}</option>)
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrCountries && <span className="role-field-error">⚠ {ErrCountries}</span>}
                                </div>
                            </div>

                            <div className="role-field-group">
                                <label className="role-field-label" htmlFor="reg-region">Region</label>
                                <div className="role-field-control">
                                    <select id="reg-region" className="role-select" value={region} onChange={handleRegionId}>
                                        <option value="">Select Region</option>
                                        {regions.length > 0
                                            ? regions.map(o => <option key={o.id} value={o.id}>{o.region_name}</option>)
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrRegion && <span className="role-field-error">⚠ {ErrRegion}</span>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Action Buttons ────────────────────────── */}
                    <div className="role-actions">
                        {isEdit ? (
                            <>
                                <a href={'/user/list/?tag=' + userid} className="role-btn role-btn--secondary">
                                    ✕ Cancel
                                </a>
                                <button id="reg-update-btn" className="role-btn role-btn--primary" disabled={disabled}>
                                    ✏️ Update User
                                </button>
                            </>
                        ) : (
                            <button id="reg-save-btn" className="role-btn role-btn--save" disabled={disabled}>
                                💾 Save User
                            </button>
                        )}
                    </div>

                </div>
            </form>
        </div>
    );
}

export default Register;